// react
import React, { Component } from "react";
import { connect } from "react-redux";
import { Helmet } from "react-helmet-async";
import { Link } from "react-router-dom";
import theme from "../../data/theme";
import CurrencyFormat from "react-currency-format";
import Axios from "axios";
import { toast } from "react-toastify";
import { Delete } from "../../store/digitalbuynow";
import { handleSubmits } from "./BuyNow";
import { agentcustomerToken, agenttoken, PaymentToken, customertoken, userCurrency } from "../../api/shop";
import PaymentOptioncomponent from "../shop/paymentOption";
import "../blocks/files.css";
import Spinner from 'react-bootstrap/Spinner'
class CofirmdigitalOrder extends Component {
    constructor(props) {
        super(props);
        this.state = {
            paymentOption_token: false
        };
    }
    toggle(value) {
        this.setState({
            paymentOption_token: value,
        });
    }

    renderItems() {
        const { Rates } = this.props
        let buynow = JSON.parse(localStorage.getItem("digitalBuynowData"));
        console.log(Rates)
        let Amount_total = buynow[0].total_amount * buynow[0].quantity;
        return (
            <tr key={buynow[0].id} className="cart-table__row">
                <td className="cart-table__column cart-table__column--image">
                    <div className="product-image">
                        <Link
                            className="product-image__body"
                        >
                            <img
                                className="product-image__img"
                                src={buynow[0].product_images.productImage_name}
                                alt=""
                            />
                        </Link>
                    </div>
                </td>
                <td className="cart-table__column cart-table__column--product">
                    <Link className="cart-table__product-name">
                        {buynow[0].product.product_name}
                    </Link>
                    {/* {options} */}
                </td>
                <td
                    className="cart-table__column cart-table__column--price"
                    data-title="Price"
                >
                    {/*<Currency value={item.price}/>*/}
                    {/* <CurrencyFormat
                        value={buynow[0].total_amount}
                        displayType={"text"}
                        thousandSeparator={true}
                        renderText={(value) => (
                            <div>
                                {" "}
    
                                {buynow[0].currency} {value}
                            </div>
                        )}
                    /> */}
                    {userCurrency() === buynow[0].currency ? (
                        <CurrencyFormat
                            value={Math.round((Number(buynow[0].total_amount) / Number(Rates[buynow[0].currency])) * Number(Rates[userCurrency()]))
                            }
                            displayType={"text"}
                            thousandSeparator={true}
                            renderText={(value) => (
                                <div>
                                    {userCurrency()}{" "}{value}
                                </div>
                            )}
                        />
                    ) : (
                        <CurrencyFormat
                            value={((Number(buynow[0].total_amount) / Number(Rates[buynow[0].currency])) * Number(Rates[userCurrency()])).toFixed(2)
                            }
                            displayType={"text"}
                            thousandSeparator={true}
                            renderText={(value) => (
                                <div>
                                    {userCurrency()}{" "}{value}
                                </div>
                            )}
                        />
                    )
                    }
                </td>
                <td
                    className="cart-table__column cart-table__column--quantity"
                    data-title="Quantity"
                >
                    {buynow[0].quantity}
                </td>
                <td
                    className="cart-table__column cart-table__column--total"
                    data-title="Total"
                >
                    {/* <CurrencyFormat
                        value={}
                        displayType={"text"}
                        thousandSeparator={true}
                        renderText={(value) => (
                            <div>
                                {" "}
                                {buynow[0].currency} {value}
                            </div>
                        )}
                    /> */}
                    {userCurrency() === buynow[0].currency ? (
                        <CurrencyFormat
                            value={Math.round((Number(Amount_total) / Number(Rates[buynow[0].currency])) * Number(Rates[userCurrency()]))
                            }
                            displayType={"text"}
                            thousandSeparator={true}
                            renderText={(value) => (
                                <div>
                                    {userCurrency()}{" "}{value}
                                </div>
                            )}
                        />
                    ) : (
                        <CurrencyFormat
                            value={((Number(Amount_total) / Number(Rates[buynow[0].currency])) * Number(Rates[userCurrency()])).toFixed(2)
                            }
                            displayType={"text"}
                            thousandSeparator={true}
                            renderText={(value) => (
                                <div>
                                    {userCurrency()}{" "}{value}
                                </div>
                            )}
                        />
                    )
                    }
                </td>
                <td className="cart-table__column cart-table__column--remove" />
            </tr>
        );
    }

    renderCart() {

        const { Delete, Rates, activeStep } = this.props;
        const agentcustomer_Token = agentcustomerToken();
        const agentToken = agenttoken();
        const details = JSON.parse(localStorage.getItem("digitalBuynowData"));
        // console.log(details);
        let amount = details[0].total_amount * details[0].quantity;
        function ConfirmOrder() {
            let cartdetails = localStorage.getItem("digitalBuynowData");
            if (agentcustomer_Token !== null && agentToken !== null) {
                let data = {
                    user_token: agentcustomer_Token,
                    payment_option: PaymentToken(),
                    total_amount: amount,
                    agent_token: agentToken,
                    currency: userCurrency(),
                    push_number: localStorage.getItem("phone"),
                    total_vat: details[0].vat * details[0].quantity,
                    cart_details: cartdetails,
                };

                Axios.post(window.$name + '/api/order/create-digital-order', data).then((response) => {
                    toast.success(` "${response.data.message}"`);
                    localStorage.setItem('success_data', JSON.stringify(response.data.payload))
                    // localStorage.removeItem('deliveryOptions');
                    Delete();
                    // localStorage.removeItem('digitalBuynowData');
                    localStorage.removeItem('paymentOption_token');
                    if (localStorage.getItem("masterCard") === "Master Card") {
                        window.location.href="/wait-for-nmb"
                    } else {
                        handleSubmits(activeStep);
                    }
                }).catch(function (error) {
                    if (error.response) {
                        toast.error(`${error.response.data.message} `);
                    } else if (error.request) {
                        toast.error(`${error.request} `);
                    } else {
                        toast.error(`${error.message} `);
                    }
                })
            }
            else {
                let data = {
                    user_token: customertoken(),
                    // shippingAddress_token:"",
                    payment_option: PaymentToken(),
                    total_amount: amount,
                    agent_token: "",
                    currency: userCurrency(),
                    push_number: localStorage.getItem("phone"),
                    total_vat: details[0].vat * details[0].quantity,
                    // shipping_options: "",
                    cart_details: cartdetails,
                };

                Axios.post(window.$name + '/api/order/create-digital-order', data).then((response) => {
                    toast.success(` "${response.data.message}"`);
                    localStorage.setItem('success_data', JSON.stringify(response.data.payload))
                    // localStorage.removeItem('deliveryOptions');
                    Delete();
                    // localStorage.removeItem('digitalBuynowData');
                    localStorage.removeItem('paymentOption_token');
                    if (localStorage.getItem("masterCard") === "Master Card") {
                        window.location.href="/wait-for-nmb"
                    } else {
                        handleSubmits(activeStep);
                    }
                }).catch(function (error) {
                    if (error.response) {
                        toast.error(`${error.response.data.message} `);
                    } else if (error.request) {
                        toast.error(`${error.request} `);
                    } else {
                        toast.error(`${error.message} `);
                    }
                })
            }
        }

        return (
            <div className="cart d-flex justify-content-center">
                <div className="card">
                    <div className="card-title">
                        <br />
                        <h5 className="text-center">
                            REVIEW,SELECT PAYMENT OPTION AND CONFIRM YOUR ORDER ITEMS
                </h5>
                    </div>

                    <div className="card-body -mt-6 ">
                        <div style={{
                            opacity: 0.6,
                            // position: 'absolute',
                            left: 0,
                            top: 0,
                            width: '100%',
                            height: 'auto'
                        }}>
                            <Spinner
                                style={{
                                    position: 'absolute',
                                    zIndex: 99999,
                                    left: '50%',
                                    top: '50%',
                                    right: '50%',
                                    bottom: '50%'
                                }}
                                animation="grow"
                                variant="warning" />
                        </div>


                        <PaymentOptioncomponent onClick={this.toggle.bind(this)} />
                        <br />
                        <table className="cart__table cart-table">
                            <thead className="cart-table__head">
                                <tr className="cart-table__row">
                                    <th className="cart-table__column cart-table__column--image">
                                        Product Image
                      </th>
                                    <th className="cart-table__column cart-table__column--product">
                                        Product name
                      </th>
                                    <th className="cart-table__column cart-table__column--price">
                                        Price
                      </th>
                                    <th className="cart-table__column cart-table__column--quantity">
                                        Quantity
                      </th>
                                    <th className="cart-table__column cart-table__column--total">
                                        Total
                      </th>
                                    <th
                                        className="cart-table__column cart-table__column--remove"
                                        aria-label="Remove"
                                    />
                                </tr>
                            </thead>
                            <tbody className="cart-table__body">{this.renderItems()}</tbody>
                        </table>
                        <div className="cart__actions">
                            <div class="container">
                                <div className="row">
                                    <div className="col-3">
                                        <h6>
                                            <label>1 ITEM</label>
                                        </h6>
                                    </div>
                                    <div className="col-3">
                                        <h6>
                                            <label>TOTAL PRICE</label>
                                        </h6>
                                    </div>

                                    <div className="col-3 ">
                                        <h6>
                                            {/* <CurrencyFormat
                            value={amount}
                            displayType={"text"}
                            thousandSeparator={true}
                            renderText={(value) => (
                              <div>
                                {" "}
                                {details[0].currency} {"  "} {value}
                              </div>
                            )}
                          /> */}
                                            {userCurrency() === details[0].currency ? (
                                                <CurrencyFormat
                                                    value={Math.round((Number(amount) / Number(Rates[details[0].currency])) * Number(Rates[userCurrency()]))
                                                    }
                                                    displayType={"text"}
                                                    thousandSeparator={true}
                                                    renderText={(value) => (
                                                        <div>
                                                            {userCurrency()}{" "}{value}
                                                        </div>
                                                    )}
                                                />
                                            ) : (
                                                <CurrencyFormat
                                                    value={((Number(amount) / Number(Rates[details[0].currency])) * Number(Rates[userCurrency()])).toFixed(2)
                                                    }
                                                    displayType={"text"}
                                                    thousandSeparator={true}
                                                    renderText={(value) => (
                                                        <div>
                                                            {userCurrency()}{" "}{value}
                                                        </div>
                                                    )}
                                                />
                                            )
                                            }
                                        </h6>
                                    </div>
                                    {/* <div className="col-3">
                        {shipping.map((address) => (
                          <div>
                            {address.is_active ? (
                              <button
                                onClick={() => ConfirmOrder(address.secure_token)}
                                type="submit"
                                disabled={
                                  !this.state.paymentOption_token
                                }
                                className="btn-sm btn btn-primary rounded shadow-lg"
                              >
                                CONFIRM ORDER
                              </button>
                            ) : (
                                <div />
                              )}
                          </div>
                        ))}
                      </div> */}

                                    <div className="col-3">
                                        {localStorage.getItem("pushValue") === true ? (
                                            <button
                                                disabled={
                                                    !this.state.paymentOption_token ||
                                                    localStorage.getItem("pushValue") === false
                                                }
                                                onClick={() => ConfirmOrder()}
                                                type="submit"
                                                className="btn-sm btn btn-primary "
                                            >
                                                CONFIRM
                                            </button>
                                        ) : (
                                            <button
                                                disabled={
                                                    !this.state.paymentOption_token
                                                }
                                                onClick={() => ConfirmOrder()}
                                                type="submit"
                                                className="btn-sm btn btn-primary "
                                            >
                                                CONFIRM
                                            </button>
                                        )}
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        );
    }
    render() {
        let content;
        content = this.renderCart();
        return (
            <React.Fragment>
                <Helmet>
                    <title>{`Confirm Order — ${theme.name}`}</title>
                </Helmet>
                <div className="mt-4">
                    {content}
                </div>
            </React.Fragment>
        );
    }
}

const mapStateToProps = (state) => ({
    buy: state.buynow,
    Rates: state.RateList,

});

const mapDispatchToProps = {
    Delete,
};

export default connect(mapStateToProps, mapDispatchToProps)(CofirmdigitalOrder);
